// University of New Hampshire's bachelor's majors (#2740). Read on 2026-10-01
// from the official UNH Undergraduate Catalog 2026-2027 (catalog.unh.edu): every
// bachelor's program page under the five Durham colleges, from the catalog's
// own sitemap, named by each page's title. Options ("Major: X Option") are
// folded into their major. Dual majors (taken alongside a
// first major) are listed with no degree. The Pre-Business and Pre-Teaching paths are left
// out, as are minors, certificates, graduate programs and the College of
// Professional Studies' online and Manchester programs.
const majors = {
    "slug": "university-of-new-hampshire",
    "read": "2026-10-01",
    "intro": "Every bachelor's major in UNH's official 2026-2027 Undergraduate Catalog for its five Durham colleges, with the degree it leads to. Options within a major, minors and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Liberal Arts",
            "source": {
                "label": "UNH Undergraduate Catalog 2026-2027, College of Liberal Arts",
                "url": "https://catalog.unh.edu/undergraduate/liberal-arts/programs-study/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Arts",
                    "degree": "B.A."
                },
                {
                    "name": "Classics",
                    "degree": "B.A."
                },
                {
                    "name": "Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Education",
                    "degree": "B.A."
                },
                {
                    "name": "Educational Studies (dual major)",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "English Literature",
                    "degree": "B.A."
                },
                {
                    "name": "English Teaching",
                    "degree": "B.A."
                },
                {
                    "name": "Fine Arts",
                    "degree": "B.F.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "Geography",
                    "degree": "B.A."
                },
                {
                    "name": "German",
                    "degree": "B.A."
                },
                {
                    "name": "Global Studies (dual major)",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Humanities (dual major)",
                    "degree": null
                },
                {
                    "name": "Interdisciplinary Humanities",
                    "degree": "B.A."
                },
                {
                    "name": "International Affairs",
                    "degree": "B.A."
                },
                {
                    "name": "Italian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Journalism and Media Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Justice Studies (dual major)",
                    "degree": null
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music Education",
                    "degree": "B.M."
                },
                {
                    "name": "Music Performance Study",
                    "degree": "B.M."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Russian",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Women's and Gender Studies",
                    "degree": "B.A."
                },
                {
                    "name": "World Languages (dual major)",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Life Sciences and Agriculture",
            "source": {
                "label": "UNH Undergraduate Catalog 2026-2027, College of Life Sciences and Agriculture",
                "url": "https://catalog.unh.edu/undergraduate/life-sciences-agriculture/programs-study/"
            },
            "majors": [
                {
                    "name": "Agriculture and Food Systems",
                    "degree": "B.A."
                },
                {
                    "name": "Agriculture and Food Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Animal Science",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry, Molecular and Cellular Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Science",
                    "degree": "B.S."
                },
                {
                    "name": "Community and Environmental Planning",
                    "degree": "B.S."
                },
                {
                    "name": "Diagnostic Science",
                    "degree": "B.S."
                },
                {
                    "name": "EcoGastronomy (dual major)",
                    "degree": null
                },
                {
                    "name": "Environmental Conservation and Sustainability",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Forestry",
                    "degree": "B.S.F."
                },
                {
                    "name": "Genetics",
                    "degree": "B.S."
                },
                {
                    "name": "Marine, Estuarine and Freshwater Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Microbiology",
                    "degree": "B.S."
                },
                {
                    "name": "Neuroscience and Behavior",
                    "degree": "B.S."
                },
                {
                    "name": "Nutrition",
                    "degree": "B.S."
                },
                {
                    "name": "Sustainability (dual major)",
                    "degree": null
                },
                {
                    "name": "Wildlife and Conservation Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Zoology",
                    "degree": "B.A."
                },
                {
                    "name": "Zoology",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Engineering and Physical Sciences",
            "source": {
                "label": "UNH Undergraduate Catalog 2026-2027, College of Engineering and Physical Sciences",
                "url": "https://catalog.unh.edu/undergraduate/engineering-physical-sciences/programs-study/"
            },
            "majors": [
                {
                    "name": "Analytics",
                    "degree": "B.S."
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Bioengineering",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Earth Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Earth and Environmental Sciences",
                    "degree": "B.A."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Engineering Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Information Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics Education",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Ocean Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Statistics",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Health and Human Services",
            "source": {
                "label": "UNH Undergraduate Catalog 2026-2027, College of Health and Human Services",
                "url": "https://catalog.unh.edu/undergraduate/health-human-services/programs-study/"
            },
            "majors": [
                {
                    "name": "Communication Sciences and Disorders",
                    "degree": "B.S."
                },
                {
                    "name": "Exercise Science",
                    "degree": "B.S."
                },
                {
                    "name": "Health Management and Policy",
                    "degree": "B.S."
                },
                {
                    "name": "Health Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Health and Physical Activity Promotion",
                    "degree": "B.S."
                },
                {
                    "name": "Human Development and Family Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Nursing",
                    "degree": "B.S.N."
                },
                {
                    "name": "Occupational Therapy",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health",
                    "degree": "B.S."
                },
                {
                    "name": "Recreation Management and Policy",
                    "degree": "B.S."
                },
                {
                    "name": "Social Work",
                    "degree": "B.S."
                },
                {
                    "name": "Sport Management and Leadership",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Peter T. Paul College of Business and Economics",
            "source": {
                "label": "UNH Undergraduate Catalog 2026-2027, Peter T. Paul College of Business and Economics",
                "url": "https://catalog.unh.edu/undergraduate/business-economics/programs-study/"
            },
            "majors": [
                {
                    "name": "Analytical Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                }
            ]
        }
    ]
};

export default majors;
